import { ButtonProps } from '@kcftech/design-system';
import { usePopup } from 'custom_hooks/usePopup';
import { ReactNode } from 'react';
import { StyledButton } from 'shared/button/Button';
import { ConfirmActionPopup } from 'shared/triggered_popup/ConfirmActionPopup';
import { PopupPlacement } from 'shared/triggered_popup/TriggeredPopup';

type ConfirmCloseButtonProps = Readonly<{
    children: ReactNode;
    onClose: () => void;
    shouldConfirm: boolean;
    confirmMessage: ReactNode;
    confirmLabel: string;
    cancelLabel?: string;
    appearance?: ButtonProps['appearance'];
    spacing?: ButtonProps['spacing'];
    placement?: PopupPlacement;
    disabled?: boolean;
    'test-id': string;
}>;

export function ConfirmCloseButton({
    children,
    onClose,
    shouldConfirm,
    confirmMessage,
    confirmLabel,
    cancelLabel = 'Cancel',
    appearance = 'secondary',
    spacing,
    placement = 'top',
    disabled = false,
    'test-id': testId,
}: ConfirmCloseButtonProps) {
    const { isOpen, open, close, triggerRef, popupRef } = usePopup<HTMLButtonElement>();

    return (
        <>
            <StyledButton
                ref={triggerRef}
                type="button"
                appearance={appearance}
                spacing={spacing}
                disabled={disabled}
                onClick={() => (shouldConfirm ? open() : onClose())}
            >
                {children}
            </StyledButton>
            {isOpen && (
                <ConfirmActionPopup
                    ref={popupRef}
                    anchorRef={triggerRef}
                    placement={placement}
                    destructive
                    noButtonLabel={cancelLabel}
                    yesButtonLabel={confirmLabel}
                    onNo={close}
                    onYes={onClose}
                    test-id={testId}
                >
                    {confirmMessage}
                </ConfirmActionPopup>
            )}
        </>
    );
}
